import React, { useEffect } from "react";

const SURPRISE_DISPLAY = {
  stars: { icon: "⭐", label: "Bonus Stars!" },
  sticker: { icon: "🎟️", label: "New Sticker!" },
  points: { icon: "💜", label: "Purple Points!" },
  confetti: { icon: "🎉", label: "Confetti Party!" },
  animal: { icon: "🐣", label: "Bonus Animal Unlock!" },
};

export default function Celebration({ stars, isNewBest, surpriseBox, onContinue, continueLabel = "Continue" }) {
  useEffect(() => {
    const el = document.getElementById("tinythink-continue-btn");
    el?.focus();
  }, []);

  const surprise = surpriseBox ? SURPRISE_DISPLAY[surpriseBox.type] : null;

  return (
    <div
      className="fixed inset-0 bg-[#2B2140]/40 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-3xl shadow-xl max-w-sm w-full p-6 text-center animate-[pop_0.3s_ease-out]">
        <div className="text-5xl mb-2" aria-hidden="true">
          {isNewBest ? "🏆" : "✨"}
        </div>
        {isNewBest && (
          <p className="text-sm font-bold text-[#FF8B6B] mb-1 tracking-wide uppercase">New Best!</p>
        )}
        <div className="flex justify-center gap-1 mb-3" aria-label={`${stars} out of 5 stars`}>
          {[1, 2, 3, 4, 5].map((n) => (
            <span key={n} className={`text-2xl sm:text-3xl ${n <= stars ? "opacity-100" : "opacity-20"}`}>
              ⭐
            </span>
          ))}
        </div>

        {surprise && (
          <div className="bg-[#F3EEFF] rounded-2xl p-3 mb-4 flex items-center justify-center gap-2">
            <span className="text-2xl" aria-hidden="true">{surprise.icon}</span>
            <span className="text-sm font-semibold text-[#7C3AED]">{surprise.label}</span>
          </div>
        )}

        <button
          id="tinythink-continue-btn"
          onClick={onContinue}
          className="w-full bg-[#7C3AED] hover:bg-[#6D28D9] text-white font-bold rounded-2xl py-3 text-base sm:text-lg transition-colors"
        >
          {continueLabel}
        </button>
      </div>
    </div>
  );
}
